






import {Component, Prop} from 'vue-property-decorator';
import EntityType from "@/models/Shared/EntityType";
import ComponentLocation from '@/models/Shared/ComponentLocation';
import GiganautVue from '@/components/Shared/GiganautVue';


@Component({
  name: 'OpenEntityInNewWindowBtn',
})
export default class extends GiganautVue {

	@Prop()
	entityId: string;
	@Prop()
	entityType: EntityType;
	@Prop()
	location: ComponentLocation;

	get small() {
		return this.location === ComponentLocation.ListRow;
	}

	async openInNewWindow() {
		switch (this.entityType) {
			case EntityType.Worker:
				window.open(window.location.origin + "/agency/workers/" + this.entityId);
				break;
			case EntityType.Location:
				window.open(window.location.origin + "/agency/locations/" + this.entityId);
				break;
			case EntityType.Contact:
				window.open(window.location.origin + "/agency/contacts/" + this.entityId);
				break;
			case EntityType.Booking:
				window.open(window.location.origin + "/agency/bookings/" + this.entityId);
				break;
			case EntityType.Company:
				window.open(window.location.origin + "/agency/companies/" + this.entityId);
				break;
			case EntityType.Job:
				window.open(window.location.origin + "/agency/jobs/" + this.entityId);
				break;
			case EntityType.Opportunity:
				window.open(window.location.origin + "/agency/opportunities/" + this.entityId);
				break;
			case EntityType.Campaign:
				window.open(window.location.origin + "/agency/campaigns/" + this.entityId);
				break;
			default:
				break;
		}

  }
	
}
